import {APIDefinitionSpec, defineEndpoint, APIDataSpec, APITransform, LocalStorageType} from '../API';
import {LOCAL_STORAGE_KEYS} from '../../services/localStorageAdapter';
import {SettingsState, SettingsData, SettingsInitialState} from '../../store/partials/Settings';
import {Immutable} from '../../store/State';
import {AccountInfo} from '../../store/partials/Authentication';
import {App, UserLayout, NewUserLayout, SearchEngine} from '../../types/commons';

export enum UserAPI {
    APPS = 'USER_APPS',
    INFO = 'USER_INFO',
    SEARCH_ENGINES = 'SEARCH_ENGINES',
    SEND_BUG = 'USER_SEND_BUG',
    SEND_FEEDBACK = 'USER_SEND_FEEDBACK',
    SETTINGS = 'USER_SETTINGS',
    SNAPSHOTS = 'USER_SNAPSHOTS',
    STATS = 'USER_STATS',
    UPDATE_PASSWORD = 'USER_UPDATE_PASSWORD',
}

const snapshotTransform: APITransform<UserTypes[UserAPI.SNAPSHOTS]> = {
    POST: (result: NewUserLayout): {status: string; snapshot: UserLayout} => ({
        status: 'ok',
        snapshot: result as UserLayout
    })
};

export const UserData: APIDataSpec<typeof UserAPI> = {
    APPS: defineEndpoint(UserAPI.APPS, 'api/user/apps?scope=${scope}', {
        storage: {type: LocalStorageType.ARRAY, key: LOCAL_STORAGE_KEYS.APPS}
    }),
    INFO: defineEndpoint(UserAPI.INFO, 'api/user/info'),
    SEARCH_ENGINES: defineEndpoint(UserAPI.SEARCH_ENGINES, 'api/user/search-engines'),
    SEND_BUG: defineEndpoint(UserAPI.SEND_BUG, 'api/user/feedback/bug'),
    SEND_FEEDBACK: defineEndpoint(UserAPI.SEND_FEEDBACK, 'api/user/feedback/feature'),
    SETTINGS: defineEndpoint(UserAPI.SETTINGS, 'api/user/settings', {
        storage: {type: LocalStorageType.ARRAY, key: LOCAL_STORAGE_KEYS.SETTINGS, default: SettingsInitialState}
    }),
    SNAPSHOTS: defineEndpoint(UserAPI.SNAPSHOTS, 'api/user/snapshots/${id}', {
        storage: {type: LocalStorageType.ARRAY, key: LOCAL_STORAGE_KEYS.LAYOUTS, transform: snapshotTransform},
        defaultParams: {id: ''}
    }),
    STATS: defineEndpoint(UserAPI.STATS, 'api/user/stats'),
    UPDATE_PASSWORD: defineEndpoint(UserAPI.UPDATE_PASSWORD, 'api/user/password')
};
export interface UserTypes extends APIDefinitionSpec<UserAPI> {
    [UserAPI.APPS]: {
        GET: [App[], {scope: 'user' | 'all'}];
    };
    [UserAPI.INFO]: {
        GET: [AccountInfo, void];
    };
    [UserAPI.SNAPSHOTS]: {
        GET: [UserLayout[], void];
        POST: [{status: string; snapshot: UserLayout}, void, NewUserLayout];
        PUT: [{status: string; name: string; snapshot: UserLayout}, {id: string}, NewUserLayout];
        DELETE: [void, {id: string}, void];
    };
    [UserAPI.UPDATE_PASSWORD]: {
        GET: [void, void];
    };
    [UserAPI.SEARCH_ENGINES]: {
        GET: [SearchEngine[], void];
    };
    [UserAPI.SEND_BUG]: {
        GET: [void, void];
    };
    [UserAPI.SEND_FEEDBACK]: {
        GET: [void, void];
    };
    [UserAPI.SETTINGS]: {
        GET: [SettingsData, void];
        POST: [void, void, {settings: Immutable<SettingsState>}];
    };
    [UserAPI.STATS]: {
        POST: [void, void, any[]];
    };
}
